export function putToStorage(key, data) {
    if (!localStorage.hasOwnProperty(key)) {
        try {
            localStorage.setItem(key,
                JSON.stringify(data));
        } catch (e) {
            console.warn(e);
        }
    }
}

export function getFromStorage(key) {
    try {
        if (localStorage.hasOwnProperty(key)) {
            return JSON.parse(localStorage.getItem(key));
        }
    } catch (e) {
        console.warn(`Local storage doesn't have ${key} value`);
    }
    return undefined;
}

export function hasLocalData(key) {
    return localStorage.hasOwnProperty(key);
}

export function purge(keys) {
    const items = keys || [
        'type-active',
        'type-inactive',
        'type-weatherbys',
        'results-active',
        'results-inactive',
        'results-weatherbys',
        'version',
    ];

    items.forEach(i => localStorage.removeItem(i));
}



// WEBPACK FOOTER //
// ./src/client/utils/localStorageHelper.js